import { Box, BrandedBarcodeIcon, Tooltip, useTheme } from '@csp/csp-web-ui';
import { FC } from 'react';
import { StaticContentService } from '../service/StaticContentService';

type Props = {
  isScanningAvailable: boolean;
};

export const BarcodeScanningAvailability: FC<Props> = ({ isScanningAvailable }) => {
  const { palette } = useTheme();
  const texts = StaticContentService.getGenericEntry('webHcpHbsCommon');

  return (
    <Tooltip
      placement="bottom"
      arrow
      title={
        isScanningAvailable
          ? texts.sampleInput.textLabel.scanningAvailable.tooltip
          : texts.sampleInput.textLabel.scanningNotAvailable.tooltip
      }
    >
      <Box
        sx={{
          color: isScanningAvailable ? 'success.contrastText' : 'common.white',
          justifyContent: 'center',
          borderRadius: '4px',
          height: '40px',
          width: '53px',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',

          ':after': !isScanningAvailable
            ? {
                content: '""',
                position: 'absolute',
                height: '3px',
                width: '53px',
                backgroundColor: palette.grey[400],
                left: 0,
                top: '50%',
                transform: 'rotate(-35deg)',
              }
            : undefined,
        }}
      >
        <BrandedBarcodeIcon color={isScanningAvailable ? 'successDark' : 'grey'} size="xxl" />
      </Box>
    </Tooltip>
  );
};
